import balancesActionTypes from '../actionTypes/balancesActionTypes';

const initialStore = {
  balancesList: [],
  balancesIsLoading: false,
  balancesError: null,
  depositData: null,
  depositDataIsLoading: false,
  tokensList: [],
  tokenListIsLoading: false,
  withdrawIsLoading: false,
  withdrawSuccess: false,
  transactionsHistory: [],
  transactionsIsLoading: false,
};

const reducer = (state = initialStore, { type, payload }) => {
  switch (type) {
    case balancesActionTypes.GET_USER_BALANCES_START:
      return {
        ...state,
        balancesIsLoading: true,
        balancesError: false,
      };
    case balancesActionTypes.GET_USER_BALANCES_SUCCESS:
      return {
        ...state,
        balancesList: payload.data.account || [],
        balancesIsLoading: false,
      };
    case balancesActionTypes.GET_USER_BALANCES_FAIL:
      return {
        ...state,
        balancesIsLoading: false,
        balancesError: payload,
      };
    case balancesActionTypes.GET_TRANSACTIONS_HISTORY_START:
      return {
        ...state,
        transactionsIsLoading: true,
      };
    case balancesActionTypes.GET_TRANSACTIONS_HISTORY_SUCCESS:
      return {
        ...state,
        transactionsHistory: payload || [],
        transactionsIsLoading: false,
      };
    case balancesActionTypes.GET_TRANSACTIONS_HISTORY_FAIL:
      return {
        ...state,
        transactionsIsLoading: false,
      };
    case balancesActionTypes.GET_DEPOSIT_DATA_START:
      return {
        ...state,
        depositDataIsLoading: true,
      };
    case balancesActionTypes.GET_DEPOSIT_DATA_SUCCESS:
      return {
        ...state,
        depositData: payload,
        depositDataIsLoading: false,
      };
    case balancesActionTypes.GET_DEPOSIT_DATA_FAIL:
      return {
        ...state,
        depositDataIsLoading: false,
      };
    case balancesActionTypes.GET_TOKENS_LIST_START:
      return {
        ...state,
        tokenListIsLoading: true,
      };
    case balancesActionTypes.GET_TOKENS_LIST_SUCCESS:
      return {
        ...state,
        tokensList: payload || [],
        tokenListIsLoading: false,
      };
    case balancesActionTypes.GET_TOKENS_LIST_FAIL:
      return {
        ...state,
        tokenListIsLoading: false,
      };
    case balancesActionTypes.GET_TOKENS_LIST_BY_SEARCH_VALUE_START:
      return {
        ...state,
        tokenListIsLoading: true,
      };
    case balancesActionTypes.GET_TOKENS_LIST_BY_SEARCH_VALUE_END:
      return {
        ...state,
        tokenListIsLoading: false,
      };
    case balancesActionTypes.GET_WITHDRAW_START:
      return {
        ...state,
        withdrawIsLoading: true,
      };
    case balancesActionTypes.GET_WITHDRAW_SUCCESS:
      return {
        ...state,
        withdrawSuccess: true,
        withdrawIsLoading: false,
      };
    case balancesActionTypes.GET_WITHDRAW_FAIL:
      return {
        ...state,
        withdrawIsLoading: false,
        withdrawSuccess: false,
      };
    default:
      return state;
  }
};

export default reducer;
